import React from 'react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { situations } from '../../data/situations';
export function Situations() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-label="Familiar situations" data-id="element-315" data-mp="2tf2iqx4vfbth">
      <div className="mx-auto max-w-5xl" data-id="element-316" data-mp="2ogr8wmekt1b9">
        <SectionHeading title={<>
              Do these situations <span className="text-alert" data-id="element-318" data-mp="2jhoctrgkq5ff">sound familiar?</span>
            </>} subtitle="If you work with growing patients, you’ve probably encountered questions like these." data-id="element-317" data-mp="2ofpymk5dwiul" />

        <ol className="mt-10 grid gap-x-10 md:grid-cols-2" data-id="element-319" data-mp="2ahrknfuz6ofm">
          {situations.map((item, i) => <li key={item.question} className="flex gap-4 border-t border-navy-900/10 py-6" data-id="element-320" data-mp="25ion0ghbrkho" data-mpi={i}>
              <span className="font-display text-3xl font-black leading-none text-electric" data-id="element-321" data-mp="8obs2dfbuzi0">{i + 1}</span>
              <div data-id="element-322" data-mp="3rlebwqzwfzr">
                <h3 className="font-display text-lg font-extrabold leading-snug text-navy-950" data-id="element-323" data-mp="3r1ugahsbhj3">“{item.question}”</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink/70" data-id="element-324" data-mp="137g2nz09pyon">{item.answer}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-8 rounded-3xl bg-navy-950 px-6 py-9 text-center text-white sm:px-12 sm:py-12" data-id="element-325" data-mp="u5giwyxvcgi0">
          <p className="font-display text-xl font-black uppercase leading-tight text-gold sm:text-2xl" data-id="element-326" data-mp="z4b05wg6tx00">
            Here’s what I want you to understand:
          </p>
          <p className="mt-4 text-lg font-semibold sm:text-xl" data-id="element-327" data-mp="1qv7dsza2o5oc">You don’t have to study every topic in isolation.</p>
          <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/80" data-id="element-328" data-mp="1d42j8blka3kv">
            MAXILLARY GROWTH BLUEPRINT™ organizes these concepts into a connected learning pathway — from growth
            fundamentals to clinical assessment and planning considerations.
          </p>
          <div className="mt-8" data-id="element-329" data-mp="2aiwxskbrp1n0">
            <CtaButton label="Explore the complete blueprint" data-id="element-330" data-mp="2ak80shxe25d2" />
          </div>
        </div>
      </div>
    </section>;
}